'use client'
const PHANTOM_REDIRECT_CONNECTION_TYPE_KEY = 'phantom-redirect-connection-type';

export { PHANTOM_REDIRECT_CONNECTION_TYPE_KEY };
